import { fetchRequest } from "../fetchRequest";
import { URLs } from "../url";
import { PlanResponse } from "../../model/plan";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";

const getPlans = async (
  enable: boolean,
  page: number,
  limit: number,
  projectId?: string,
  name?: string,
  paymentModeId?: string,
  coverTypeId?: string,
  clientId?: string,
  planId?: string
) => {
  const newURL =
    process.env.REACT_APP_HOST_API +
    URLs.plans +
    `?enable=${enable}&page=${page}&limit=${limit}&includePrice=true` +
    (projectId ? `&projectId=${projectId}` : "") +
    (paymentModeId ? `&paymentModeId=${paymentModeId}` : "") +
    (coverTypeId ? `&coverTypeId=${coverTypeId}` : "") +
    (name ? `&name=${decodeURIComponent(name)}` : "") +
    (clientId ? `&clientId=${clientId}` : "") +
    (planId ? `&ids=${planId}` : "");

  const requestOptions = {
    method: "GET",
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getPlanIdApi = async (id: string) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.plans + `/${id}`;

  const requestOptions = {
    method: "GET",
    headers: getHeader(),
  };

  try {
    return await fetchRequest(newURL, requestOptions);
  } catch (error: any) {
    throw error;
  }
};

const postPlanApi = async (body: any) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.plans;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };
  try {
    return (await fetchRequest(newURL, requestOptions)) as PlanResponse;
  } catch (error: any) {
    throw error;
  }
};

const patchPlanApi = async (body: any, id: string) => {
  console.log("patch", body, id);
  let newURL = process.env.REACT_APP_HOST_API + URLs.plans + `/${id}`;
  const requestOptions = {
    method: "PATCH",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };

  try {
    return (await fetchRequest(newURL, requestOptions)) as PlanResponse;
  } catch (error: any) {
    throw error;
  }
};

export { getPlans, getPlanIdApi, postPlanApi, patchPlanApi };
